import { CHAIN_CONSTANTS, EIP1559_SAFETY_CONFIG } from '../common/constants'

import type {
  ValidationInput,
  EIP1559SigningPayload,
  EIP1559Transaction,
  TestnetChain,
} from '../../types'

/**
 * Generates a signing payload for an EIP-1559 transaction.
 */
export function generateEIP1559SigningPayload(
  input: ValidationInput,
): EIP1559SigningPayload {
  const constants = CHAIN_CONSTANTS[input.chain]
  const transaction: EIP1559Transaction = {
    to: EIP1559_SAFETY_CONFIG.SAFE_TO_ADDRESS,
    value: EIP1559_SAFETY_CONFIG.SAFE_VALUE,
    data: EIP1559_SAFETY_CONFIG.SAFE_DATA,
    gasLimit: EIP1559_SAFETY_CONFIG.SAFE_GAS_LIMIT,
    maxFeePerGas: EIP1559_SAFETY_CONFIG.SAFE_MAX_FEE_PER_GAS,
    maxPriorityFeePerGas: EIP1559_SAFETY_CONFIG.SAFE_MAX_PRIORITY_FEE,
    nonce: EIP1559_SAFETY_CONFIG.getSafeNonce(),
    chainId: parseInt(constants.chainId, 10),
  }

  return {
    chain: input.chain as
      | TestnetChain.EthereumSepolia
      | TestnetChain.PolygonAmoy
      | TestnetChain.BaseSepolia,
    walletAddress: input.walletAddress,
    payload: transaction,
  }
}
